export enum HudOverlayType {
    Waves = "WavesHudOverlay",
    Tides = "TideHudOverlay",
    Winds = "WindHudOverlay",
}